export const GETME: any = 'YEOLMAE' // user info
export const AVATAR: any = 'AVATAR'
export const TOKEN: any = 'TOKEN'
